import { render, staticRenderFns } from "./TicketsTable.vue?vue&type=template&id=085e75d0&scoped=true"
import script from "./TicketsTable.vue?vue&type=script&lang=js"
export * from "./TicketsTable.vue?vue&type=script&lang=js"
import style0 from "./TicketsTable.vue?vue&type=style&index=0&id=085e75d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085e75d0",
  null
  
)

export default component.exports